module.exports = __webpack_public_path__ + "static/media/Benjamin Harrison - 1888.1cdced37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Benjamin Harrison - 1888.jpg
// module id = 445
// module chunks = 0